import { Card } from '@citizen-walk/shared-ui';
import type { StreetSurveyPost } from './useStreetSurveyPosts';

export interface StreetSurveyInsightPanelProps {
  post: StreetSurveyPost | null;
}

export function StreetSurveyInsightPanel({ post }: StreetSurveyInsightPanelProps) {
  if (!post) {
    return (
      <Card padding="md" className="mt-4">
        <p className="text-sm text-slate-500">地図で地点を選択してください。</p>
      </Card>
    );
  }

  return (
    <Card padding="md" className="mt-4 space-y-3">
      {post.professionalInsight && (
        <p
          className="text-sm font-medium text-amber-900 bg-amber-50 border border-amber-200 rounded px-3 py-2"
          title={post.professionalInsight}
        >
          💡 {post.professionalInsight}
        </p>
      )}
      {post.provider === 'google' ? (
        <p className="text-xs text-rose-700 bg-rose-50 border border-rose-200 rounded px-3 py-2">
          ⚠ Google ストリートビューの車載カメラの画像です（カメラの高さ:
          約2.5m）。人の目の高さとは見え方が異なる場合があります。
        </p>
      ) : (
        <p className="text-xs text-slate-600 bg-slate-50 border border-slate-200 rounded px-3 py-2">
          登録済みの360°写真から解析した地点です
          {post.fileName ? `（${post.fileName}）` : ''}。
        </p>
      )}
      {post.description && <p className="text-sm text-slate-700">{post.description}</p>}
      {/* 従来方式は 4 方向を別々に解析し、説明文などの分類以外の項目は前方の画像の結果を使う
          (docs/98 R-98 中)。新方式は 4 方向をまとめて説明文を作る。 */}
      {(post.description || post.professionalInsight) &&
        post.analysisStatus === 'done' &&
        !post.streetView?.extraction && (
          <p className="text-[11px] text-slate-500">
            従来の方式で解析した地点のため、説明文などは前方の画像だけから作られています（検出要素は
            4 方向すべて）。新方式で再解析すると、4 方向をまとめた説明文になります。
          </p>
        )}
    </Card>
  );
}
